export default "__VITE_ASSET__12c9de2e__"